"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredPlaidAction = void 0;
var RequiredPlaidAction;
(function (RequiredPlaidAction) {
    RequiredPlaidAction["launchLinkInUpdateMode"] = "launchLinkInUpdateMode";
    RequiredPlaidAction["launchLinkInNormalMode"] = "launchLinkInNormalMode";
})(RequiredPlaidAction || (exports.RequiredPlaidAction = RequiredPlaidAction = {}));
